import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography} from "@mui/material"
import axios from "axios"
import {openPrimaryWorkspace} from "../../../reducers/workspaceSlice"
import {getImportedArticleCountForWorkspace} from "../../../reducers/freeTierTrackerslice"
import {useDispatch, useSelector} from "react-redux"
import {useSnackbar} from "notistack"
import {
	selectOpenSwitchWorkspaceModal,
	selectTargetWorkspace,
	setSwitchWorkspaceModal
} from "../../../reducers/notificationsSlice"
import {useWorkspaceContext} from "../../../pages/Dashboard"

export default function SwitchWSModal() {
	const dispatch = useDispatch()
	const {workspaceId} = useWorkspaceContext()
	const { enqueueSnackbar } = useSnackbar()
	const targetWorkspace = useSelector((state) => selectTargetWorkspace(state, workspaceId))
	const openModal = useSelector(selectOpenSwitchWorkspaceModal)

	const handleCancel = () => {
		dispatch(setSwitchWorkspaceModal(false))
	}

	const handleAgree = async () => {
		if (!targetWorkspace) {
			enqueueSnackbar(
				"Something went wrong selecting the workspace notification",
				{
					variant: "error",
					autoHideDuration: 3000,
				}
			)
			return
		}

		try {
			const url = `/api/workspace/${targetWorkspace?.id}/userWorkspace`
			const {data: userWorkspace} = await axios.get(url)
			const workspace = userWorkspace.workspace
			const {admin, read, write} = userWorkspace
			const permissions = {admin, read, write}

			await dispatch(openPrimaryWorkspace({
				...workspace,
				permissions,
				ownerIsFreeTier: userWorkspace.ownerIsFreeTier,
				ownerIsSuperadmin: userWorkspace.ownerIsSuperadmin
			}))
			if(userWorkspace.ownerIsFreeTier) {
				await dispatch(getImportedArticleCountForWorkspace({fullWorkspace: workspace}))
			}
			//localStorage.removeItem("recently-viewed-articles" + workspace.id)
			dispatch(setSwitchWorkspaceModal(false))
		} catch(e) {
			enqueueSnackbar(
				"Something went wrong switching workspaces",
				{
					variant: "error",
					autoHideDuration: 3000,
				}
			)
		}

	}

	return (
		<Dialog
			open={openModal}
			onClose={() => dispatch(setSwitchWorkspaceModal(false))}
		>
			<DialogTitle>
				Switch workspaces
			</DialogTitle>
			<DialogContent>
				<DialogContentText>
					You are about to switch the <Typography variant="accentedText">{targetWorkspace?.title}</Typography> workspace
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleAgree}>Confirm</Button>
			</DialogActions>
		</Dialog>
	)
}